define('controllers/consoleApi/privacy.contactorsList.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('privacyContactorListCtrl', ['$scope', '$q', '$state', '$stateParams', '$rootScope', 'projectManageService', 'auiDialog',
        function ($scope, $q, $state, $stateParams, $rootScope, projectManageService, auiDialog) {
            var Model = $scope.Model = {
                query: {
                    pagination: {
                        currentPage: 1,// 当前页
                        itemsPerPage: 10,// 默认每页个数
                        totalCount: 0,
                        noItems: "No data",
                        pagesLength: 10,// 显示的页码数量,
                        perPageOptions: [10, 20],
                        onChange: queryProcessContactList
                    }
                }
            };
            Model.contactTypeFilter = mainCons.oauthConstant.contactTypeFilter;
            $scope.addContactInfo = addContactInfo;
            $scope.modContactInfo = modContactInfo;
            $scope.delContactInfo = delContactInfo;


            init();
            function init() {
                queryProcessContactList();
            }


            function queryProcessContactList() {
                var request = {
                    fromRecCount: 1 + (Model.query.pagination.currentPage - 1) * Model.query.pagination.itemsPerPage,
                    maxReqCount: Model.query.pagination.itemsPerPage,
                    sortType: 1
                };
                projectManageService.queryProcessContact(request).then(function (data) {
                    if (data && data.resultCode == 0) {
                        Model.contactInfoList = data.contactInfoList;
                        Model.query.pagination.totalCount = data.totalCount;
                    } else {
                        Model.contactInfoList = [];
                        Model.query.pagination.totalCount = 0;
                    }
                });

            }

            function addContactInfo() {
                var defer = $q.defer();
                projectManageService.addContactInfoPage().then(function (data) {
                    if(data){
                        Model.query.pagination.currentPage = 1;
                        queryProcessContactList();
                        defer.resolve();
                    }
                });
                return defer.promise;
            }

            function modContactInfo(row) {
                var defer = $q.defer();
                var rowCopy = angular.copy(row);
                projectManageService.modContactInfoPage(rowCopy).then(function (data) {
                    if(data){
                        queryProcessContactList();
                        defer.resolve();
                    }else{
                        defer.reject();
                    }
                });
                return defer.promise;
            }

            function delContactInfo(row) {
                var defer = $q.defer();
                var delContactInfoReq = {
                    contactID:row.contactID
                }
                auiDialog.confirm("确定删除此隐私联系信息吗？", function () {
                    projectManageService.delProcessContact(delContactInfoReq).then(function (data) {
                        if (data && data.resultCode == 0) {
                            auiDialog.success("删除成功", function () {
                                Model.query.pagination.currentPage = 1;
                                queryProcessContactList();
                                defer.resolve();
                            });
                        } else {
                            defer.reject();
                        }
                    });
                },function () {
                    defer.reject();
                });
                return defer.promise;
            }


        }
    ]);
});

